module.exports = __webpack_public_path__ + "files/48c7df6f4d3d4df25748a666d0520b5c.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_SansSerif-Regular.woff
// module id = 822
// module chunks = 60